<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C6WQ5S/tc-custom/9781608463565.jpg?1728259408005" alt="This image is the cover for the book Speech"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Speech
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this “slim but powerful book,” the award-winning journalist shares the dramatic story surrounding MLK’s most famous speech and its importance today (<i>Boston Globe</i>).</b></p><p>On August 28, 1963, Dr. Martin Luther King Jr. led the historic March on Washington for Jobs and Freedom, where he delivered the most iconic speech of the civil rights movement. In <i>The Speech</i>, Gary Younge explains why King’s “I Have a Dream” speech maintains its powerful social relevance by sharing the dramatic story surrounding it. Today, that speech endures as a guiding light in the ongoing struggle for racial equality.</p><p>Younge roots his work in personal interviews with Clarence Jones, a close friend of Martin Luther King Jr. and his draft speechwriter; with Joan Baez, a singer at the march; and with Angela Davis and other leading civil rights leaders. Younge skillfully captures the spirit of that historic day in Washington and offers a new generation of readers a critical modern analysis of why “I Have a Dream” remains America’s favorite speech.</p> “Younge’s meditative retrospection on [the speech’s] significance reminds us of all the micro-moments of transformation behind the scenes—the thought and preparation, vision and revision—whose currency fed that magnificent lightning bolt in history.” —Patricia J. Williams, legal scholar and theorist
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary Younge
      </h2>
      
      <p class="authorDescription body article">Gary Younge is an author, broadcaster, and award-winning columnist for the Guardian, based in Chicago. He also writes a monthly column for The Nation magazine and is the Alfred Knobler Fellow for The Nation Institute. Born in Britain to Barbadian parents, Younge reported all over Europe, Africa, and the Caribbean before being appointed the Guardian’s US correspondent in 2003. In 2009 he won Britain’s prestigious James Cameron Award for “combined moral vision and professional integrity.” His first book, No Place Like Home: A Black Briton’s Journey through the Deep South, was shortlisted for the Guardian First Book Award. His third book, Who Are We—and Should It Matter in the 21st Century?, was shortlisted for the Bristol Festival of Ideas Book Prize. The Speech is his fourth book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haymarket Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e708ccfa